<div class="prd-complete-container">
  <!-- ============================================ -->
  <!-- SECCIÓN 1: LIFE-CIRCLE / ANÁLISIS PROFUNDO  -->
  <!-- ============================================ -->
  
  <div class="">
    <div class="container">
      <!-- Main View -->
        <!-- Header with breadcrumb -->
        <div class="header-row">
          <div class="header-left">
            <span class="breadcrumb">Descubrete > <span class="breadcrumb-active">Guía de reflexión personal</span></span>
          </div>
        </div>

        <!-- Guía de Reflexión Personal -->
        <div class="reflection-guide-section">
          <!-- Banner verde con fecha de vencimiento -->
          <div *ngIf="!reflectionGuideCompleted" class="reflection-guide-banner">
            <i class="fas fa-check-circle"></i>
            <span>Desde ahora tienes 7 días para completar tu guía de reflexión personal. Vence el {{ getFormattedExpirationDate() }}</span>
          </div>

          <!-- Encabezado principal -->
          <div class="reflection-guide-main-header">
            <h2 class="reflection-guide-main-title">Guía de reflexión personal</h2>
            <p class="reflection-guide-main-description">
              Tomarte un tiempo para reflexionar sobre tu situación actual y tu visión de futuro en las distintas áreas clave de tu vida, recuerda que <strong>tus respuestas se guardan automáticamente.</strong>
            </p>
          </div>

          <!-- Contenido de la guía de reflexión -->
          <div *ngIf="!showReflectionGuide && !reflectionGuideCompleted" class="reflection-welcome-card">
            <div class="welcome-card-content">
              <h3 class="welcome-card-title">Guía de reflexión personal</h3>
              <p class="welcome-card-description">
                Tomarte un tiempo <strong>para reflexionar</strong> sobre tu situación actual y tu visión de futuro en las distintas áreas clave de tu vida es un <strong>paso fundamental</strong> para iniciar un camino consciente de diseño y acción hacia una vida plena y con sentido.
              </p>
              <button class="btn-continue-reflection" (click)="startReflectionGuide()" 
              [disabled]="!areAllDimensionsCompleted()"
              [ngClass]="{'disabled': !areAllDimensionsCompleted()}"
              >Continuar</button>
            </div>
          </div>

          <!-- Formulario de reflexión -->
          <div *ngIf="showReflectionGuide && !reflectionGuideCompleted" class="reflection-form">
              <!-- Header con progreso -->
              <div class="reflection-form-header">
                <div class="progress-info">
                  <span class="progress-text">Sección {{ currentReflectionSection + 1 }} de {{ reflectionSections.length }}</span>
                  <div class="progress-bar">
                    <div class="progress-fill" [style.width.%]="getReflectionProgress()"></div>
                  </div>
                </div>
              </div>

              <!-- Título de la sección actual -->
              <div class="section-title" *ngIf="reflectionSections[currentReflectionSection]">
                <h3>{{ reflectionSections[currentReflectionSection].title }}</h3>
              </div>

              <!-- Preguntas de la sección actual -->
              <div class="reflection-questions" *ngIf="reflectionSections[currentReflectionSection]">
                <div *ngFor="let question of reflectionSections[currentReflectionSection].questions; let i = index" class="question-block">
                  <div class="question-number">{{ i + 1 }}</div>
                  <div class="question-content">
                    <p class="question-text">{{ question.text }}</p>
                    
                    <!-- Campo de texto simple -->
                    <div *ngIf="question.type === 'text' || question.type === 'single-text'" class="text-input-container">
                      <textarea 
                        [value]="getAnswerForQuestion(question.id)?.answer || ''"
                        (input)="updateTextAnswer(question.id, $any($event.target).value)"
                        [placeholder]="question.placeholder"
                        [rows]="question.rows || 3"
                        class="reflection-textarea">
                      </textarea>
                      <div class="character-counter" [ngClass]="{'limit-reached': isCharacterLimitReached(question.id)}">
                        {{ getCharacterCount(question.id) }}/{{ getCharacterLimit(question.id) }}
                      </div>
                    </div>

                    <!-- Campos de dimensión y subdimensión -->
                    <div *ngIf="question.type === 'dimension-pair'" class="dimension-pair-container">
                      <div class="dimension-pairs">
                          <div *ngFor="let pair of getDimensionPairs(question.id); let pairIndex = index" class="dimension-pair">
                            <div class="dimension-input-wrapper">
                              <select 
                                [(ngModel)]="pair.dimension"
                                (change)="updateDimensionPair(question.id, pairIndex, 'dimension', pair.dimension)"
                                class="dimension-select">
                                <option value="">Seleccione dimensión</option>
                                <option *ngFor="let dim of getAvailableDimensions()" [value]="dim">
                                  {{ dim }}
                                </option>
                              </select>
                            </div>
                            <div class="subdimension-input-wrapper">
                              <select 
                                [(ngModel)]="pair.subdimension"
                                (change)="updateDimensionPair(question.id, pairIndex, 'subdimension', pair.subdimension)"
                                [disabled]="!pair.dimension"
                                class="subdimension-select">
                                <option value="">Seleccione subdimensión</option>
                                <option *ngFor="let subdim of getSubdimensionsForDimension(pair.dimension)" [value]="subdim">
                                  {{ subdim }}
                                </option>
                              </select>
                            </div>
                            <div class="comment-input-wrapper">
                              <input 
                                type="text"
                                [(ngModel)]="pair.comment"
                                (input)="updateDimensionPair(question.id, pairIndex, 'comment', pair.comment || '')"
                                placeholder="Comentario de dimensión"
                                class="comment-input"
                                maxlength="200">
                            </div>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Botones de navegación -->
              <div class="reflection-navigation">
                <button 
                  *ngIf="currentReflectionSection > 0" 
                  class="btn-previous" 
                  (click)="previousReflectionSection()">
                  ← Anterior
                </button>
                <button 
                  class="btn-continue" 
                  [disabled]="!isCurrentSectionCompleted()"
                  (click)="nextReflectionSection()">
                  {{ getContinueButtonText() }}
                </button>
              </div>
          </div>

          <!-- Mensaje de finalización (si ya fue completada, se muestra solo esto) -->
          <div *ngIf="reflectionGuideCompleted && !showReflectionResults" class="reflection-completion">
            <h3>¡Felicitaciones!</h3>
            <p>Por darte este tiempo para mirar hacia adentro y calcomenzar a diseñar la vida que deseas construir!</p>
            <p *ngIf="reflectionCompletedAt" class="completion-date">Completado el: {{ reflectionCompletedAt | date:'medium' }}</p>
            <button class="btn-finish" (click)="showReflectionResults = true">Ver Resultados</button>
          </div>

          <!-- Vista de Resultados de la Guía de Reflexión -->
          <div *ngIf="showReflectionResults && reflectionGuideCompleted" class="reflection-results">
            <div class="reflection-results-header">
              <h2 class="reflection-results-title">Resultados de tu Guía de Reflexión Personal</h2>
              <p class="reflection-results-subtitle">Revisa tus respuestas y reflexiones completadas</p>
            </div>

            <div class="reflection-results-content">
              <div *ngFor="let section of reflectionSections" class="reflection-result-section">
                <h3 class="result-section-title">{{ section.title }}</h3>
                <div class="result-questions">
                  <div *ngFor="let question of section.questions" class="result-question-item">
                    <div class="result-question-text">
                      <strong>{{ question.text }}</strong>
                    </div>
                    <div class="result-question-answer">
                      <div *ngIf="question.type === 'text' || question.type === 'single-text'" class="text-answer">
                        {{ getFormattedAnswer(question.id) || 'Sin respuesta' }}
                      </div>
                      <div *ngIf="question.type === 'dimension-pair'" class="dimension-pairs-answer">
                        <div *ngFor="let pair of getDimensionPairs(question.id)" class="dimension-pair-result">
                          <div *ngIf="pair.dimension && pair.subdimension" class="pair-item">
                            <span class="dimension-label">Dimensión:</span>
                            <span class="dimension-value">{{ pair.dimension }}</span>
                            <span class="subdimension-label">Subdimensión:</span>
                            <span class="subdimension-value">{{ pair.subdimension }}</span>
                            <span *ngIf="pair.comment" class="comment-label">Comentario:</span>
                            <span *ngIf="pair.comment" class="comment-value">{{ pair.comment }}</span>
                          </div>
                        </div>
                        <div *ngIf="!hasDimensionPairs(question.id)" class="no-answer">
                          Sin respuesta
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="reflection-results-footer">
              <p *ngIf="reflectionCompletedAt" class="completion-date-footer">
                Completado el: {{ reflectionCompletedAt | date:'medium' }}
              </p>
              <div class="footer-actions">
                <button class="btn-edit-results" (click)="editReflectionAnswers()">
                  Editar respuestas
                </button>
                <button class="btn-close-results" (click)="showReflectionResults = false; isReflectionGuideExpanded = false">
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Botón para alternar la sección PRD -->
        <!-- <div *ngIf="areAllDimensionsCompleted()" class="prd-toggle-section">
          <button class="btn-toggle-prd" (click)="togglePRDSection()">
            <i class="fas" [ngClass]="showPRDSection ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
            <span>{{ showPRDSection ? 'Ocultar' : 'Ver' }} Priorización (PRD)</span>
          </button>
        </div> -->
    </div>
  </div>
</div>
